import theme, { fonts } from '@klaviyo-mkt/gatsby-components/shared/styles/themes/default';
import { clampSize } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';

import type { IHeadline } from '@klaviyo-mkt/gatsby-components/atoms/typography/variants/types';

// Create a copy of the theme for modification
const layoutTheme = { ...theme };

const h1Headline: IHeadline = {
  fontFace: fonts.sohne.regular,
  fontSize: clampSize(4, 4.8),
  lineHeight: 1.17,
};
const h1HeadlineSemibold: IHeadline = {
  ...h1Headline,
  fontFace: fonts.sohne.semibold,
};

const h2Headline: IHeadline = {
  fontFace: fonts.sohne.regular,
  fontSize: clampSize(2.4, 2.8),
  lineHeight: 1.12,
};

const h2HeadlineSemibold: IHeadline = {
  ...h2Headline,
  fontFace: fonts.sohne.semibold,
};

const h3Headline: IHeadline = {
  fontFace: fonts.sohne.regular,
  fontSize: clampSize(2, 2.4),
  lineHeight: 1.17,
};

const h3HeadlineSemibold: IHeadline = {
  ...h3Headline,
  fontFace: fonts.sohne.semibold,
};

const h4Headline: IHeadline = {
  fontFace: fonts.sohne.regular,
  fontSize: clampSize(1.6, 2),
  lineHeight: 1.2,
};

const h4HeadlineSemibold: IHeadline = {
  ...h4Headline,
  fontFace: fonts.sohne.semibold,
};

const headline = {
  ...layoutTheme.headline,
  h1: h1Headline,
  h1Semibold: h1HeadlineSemibold,
  h2: h2Headline,
  h2Semibold: h2HeadlineSemibold,
  h3: h3Headline,
  h3Semibold: h3HeadlineSemibold,
  h4: h4Headline,
  h4Semibold: h4HeadlineSemibold,
};

layoutTheme.headline = {
  ...headline,
};

layoutTheme.testimonialsTwoColumn = {
  ...theme.testimonialsTwoColumn,
  light: {
    ...theme.testimonialsTwoColumn.light,
    backgroundColor: theme.colors.white,
  },
};

layoutTheme.name = 'Editorial';

export default layoutTheme;
